module.exports = __webpack_public_path__ + "img/icon_delobank.7a7820aa.svg";